<script lang="ts" setup>
import { z } from 'zod'
import { useTypedForm } from '~/composables/useTypedForm'
import { useModal } from '~/composables/useModal'
import { useAuthStore } from '~/stores/auth'
import type { RequestPasswordResetParams } from '~/types/auth'

const { t } = useI18n('components.organisms.modal.request-password-reset-modal')

const authStore = useAuthStore()

const { modalIsOpen, closeModal } = useModal()

const {
  handleSubmit,
  resetForm,
  formProps,
  isLoading: isResettingPassword
} = useTypedForm<RequestPasswordResetParams>({
  id: 'request-password-reset-modal',
  schema: {
    email: z.email(t('error-messages.invalid-email'))
  }
})

const resetPassword = handleSubmit(async (values) => {
  const hasReset = await authStore.requestPasswordReset(values)

  if (hasReset) {
    resetForm({})
    closeModal()
  }
})
</script>

<template>
  <VModal
    v-model:open="modalIsOpen"
    indicator-text=".indicator-text"
    indicator-center
    title=".title"
    @close="closeModal"
  >
    <template #content>
      <FormWrapper
        v-if="formProps"
        v-slot="{ k }"
        v-bind="formProps"
        @submit="resetPassword"
      >
        <FormInput :name="k.email" label="labels.email" type="email" input-mode="email" />
      </FormWrapper>
    </template>

    <template #actions>
      <VButton
        type="submit"
        :form="formProps.id"
        :loading="isResettingPassword"
        color="success"
        icon-right="fa-arrow-right"
        label=".button"
      />
    </template>
  </VModal>
</template>

<style scoped></style>
